import React from "react";


// COMPONENTS
import UserDropdown from "./UserDropdown";
import CMSSearchBar from "./CMSSearchBar";
import ClearCacheButton from "../../ClearCacheButton";

// CSS STYLES
import styles from '../../../styles/layouts/DashboardHeaderBar.module.css'
// ICONS
import { IoArrowForwardOutline } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";





const DashboardHeaderBar = ({ onDrawerToggle }) => {

    const handleDirectoryRedirect = () => {
        // Redirect to the directory page on DPS CMS
        window.location.replace(`${process.env.REACT_APP_DPS_CMS_URL}/auth/directory`);
    }


    return (
        <div className={styles.headerBar_main_container}>
            {/* HIDDEN HAMBURGER (ONLY MOBILE VIEW TO OPEN MENU) */}
            <div className={styles.headerBar_hamburger_icon}>
                <GiHamburgerMenu size={30} onClick={onDrawerToggle} />
            </div>

            {/* SELECT CMS BUTTON */}
            <div className={styles.headerBar_search_container}>
                <div className={styles.dahboard_redirect_button} onClick={() => {handleDirectoryRedirect()}}>
                    <p>Select CMS App</p>
                    <IoArrowForwardOutline size={15} color={'white'}/>
                </div>
                
                <CMSSearchBar />
            </div>

            <ClearCacheButton />

            <div  className={styles.notificatins_signout_buttons_container} >
                <UserDropdown />
            </div>
                            
        </div>
    )


};

export default (DashboardHeaderBar);